<div class="grid-container landing">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 define-img-landingpage">
      <img src="assets/images/3d_boxes.jpg" alt="TMSS 2.0">
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 p-4">
      <div *ngIf="broadCastMessages.length; else noAnnouncements">
        <app-announcements [broadcastMessages]="broadCastMessages"></app-announcements>
      </div>
      <ng-template #noAnnouncements>
        <h2 class="section-header">Announcements</h2>
        <h5 class="no-announcements"><b>No Announcements at the moment.</b></h5>
      </ng-template>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <p class="padding-4">
        Welcome to TMSS 2.0 – the GSA cloud-based rate procurement solution
        that supports federal agency transportation requirements for the worldwide
        shipment of household goods and freight. Through TMSS 2.0, federal agencies
        access the Centralized Household Goods Traffic Management Program
        (CHAMP) and the Freight Management Program (FMP).
        <br><br>
        CHAMP provides the worldwide shipments of household goods, unaccompanied air
        baggage, privately-owned vehicles, storage-in-transit, extended storage and
        containerized domestic options. FMP delivers worldwide freight shipments via motor,
        rail, ocean, and air. Both of these programs feature comprehensive tenders of service,
        vetted suppliers, highly competitive rates, and a consistent pricing structure.
      </p>
    </div>
  </div>
</div>
<div class="grid-container landing-features" style="background-color: #fff;">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 define-logo-landing-page">
      <img src="assets/images/3d_gear.jpg" alt="TMSS 2.0">
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <div class="padding-4">
        <h5><b>Features of TMSS 2.0</b></h5>
        <ul>
          <li>Automate shipment planning and tendering</li>
          <li>Generate bill of lading (BOL)</li>
          <li>Request specific pickup and delivery requirements</li>
          <li>Compare costs of GSA-approved Transportation Service Providers (TSPs) to support best-value decision
            making
          </li>
          <li>Facilitate electronic communications between agency and TSP</li>
          <li>Employ advanced reporting and business intelligence tools</li>
        </ul>
      </div>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 define-logo-landing-page">
      <img src="assets/images/d3_target.jpg" alt="TMSS 2.0">
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <div class="padding-4">
        <h5><b>Benefits of TMSS 2.0</b></h5>
        <ul>
          <li>Access competed rates faster via tender procurement available exclusively to GSA for federal agencies
            and approved contractors
          </li>
          <li>Utilize system free of charge to agencies</li>
          <li>Eliminate agency cost to maintain a proprietary transportation management solution</li>
          <li>Assist agencies in complying with sustainability and socio-economic goals</li>
          <li>Customize system to agency-specific requirements</li>
        </ul>
      </div>
    </div>
  </div>
</div>
